interface TextProps {
  className?: string;
  children: any;
}

export const Text = ({ className, children }: TextProps) => {
  return <p className={`text-base ${className}`}>{children}</p>;
};
